import React from "react";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import {Box, Chip, Container, Divider, Paper, Stack, Typography} from "@mui/material";
import Grid from "@mui/material/Grid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowDown,
    faArrowUp,
    faBalanceScale,
    faExclamationTriangle,
    faLeaf,
    faQuoteRight,
    faSearchDollar,
    faUniversity,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import CandidateHeader from "../../components/layouts/others/candidat-header.layout";

// @ts-ignore
import imgStrate from "../../assets/images/articles/2025-12-30/20251230-img1.png";
// @ts-ignore
import imgCharges from "../../assets/images/articles/2025-12-30/20251230-img2.png";
// @ts-ignore
import imgTresorerie from "../../assets/images/articles/2025-12-30/20251230-img3.png";
// @ts-ignore
import imgDette from "../../assets/images/articles/2025-12-30/20251230-img4.png";

const POST20251230: React.FC = () => {

    const GraphImage = ({ src, alt }: { src: any, alt: string }) => (
        <Box
            sx={{
                width: "100%",
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                border: "1px solid #e0e0e0",
                bgcolor: "white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <img
                src={src}
                alt={alt}
                style={{
                    maxWidth: "100%",
                    height: "auto",
                    display: "block"
                }}
            />
        </Box>
    );

    return (
        <Container maxWidth="lg" sx={{mb: 8}}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS"/>

            <Box mt={3} mb={5}>
                <Typography
                    variant="h6"
                    fontWeight={700}
                    align="center"
                    gutterBottom
                    color="primary"
                >
                    <FontAwesomeIcon icon={faLeaf} style={{marginRight: 8}}/>
                    VLD2026 - Complément d'information du Tract 3, le 30&nbsp;décembre&nbsp;2025
                </Typography>
                <Divider sx={{mt: 1, mb: 3}}/>
            </Box>

            <Stack spacing={8}>

                {/* --- SECTION 1 : INTRO / JEAN-PHILIPPE GUIBERT --- */}
                <Paper
                    elevation={4}
                    sx={{
                        p: 4,
                        borderRadius: 4,
                        background: "linear-gradient(135deg, #ffffff 30%, #f0f7ff 100%)",
                        borderLeft: "6px solid #1565c0"
                    }}
                >
                    <CandidateHeader />

                    <Box mt={4}>
                        <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                            <Box sx={{ bgcolor: "#1565c0", borderRadius: "256px", p: 1, width: 40, height: 40, display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <FontAwesomeIcon icon={faBalanceScale} color="#fff" />
                            </Box>
                            <Typography variant="h5" fontWeight={800} color="#1565c0">
                                Engagement n°1 : Finances
                            </Typography>
                        </Stack>

                        <Typography variant="body1" paragraph sx={{ fontSize: "1.1rem", color: "#37474f" }}>
                            La majorité municipale voudrait nous faire croire à un bon bilan financier au prétexte qu'il serait comparable à celui de la plupart des communes.
                        </Typography>

                        <Paper elevation={0} sx={{ p: 3, bgcolor: "#fff3e0", borderRadius: 3, position: "relative", mb: 3 }}>
                            <FontAwesomeIcon icon={faQuoteRight} style={{ position: "absolute", top: 10, right: 20, fontSize: "2rem", color: "#ffe0b2" }} />
                            <Typography variant="body1" fontWeight={600} color="#e65100" sx={{ pr: 4 }}>
                                Ne soyons pas dupes : cette présentation est biaisée, car elle occulte totalement la trajectoire depuis 2018.
                            </Typography>
                        </Paper>

                        <Typography variant="body1" color="text.secondary">
                            Nous souhaitons apporter une information complémentaire pour enrichir le débat public.
                            Vous avez été nombreux à nous questionner sur l'évolution financière de Bois-le-Roi par rapport à d'autres communes.
                            Voici un complément d'information permettant une analyse comparative de la gestion financière de la commune.
                        </Typography>
                    </Box>
                </Paper>

                {/* --- SECTION 2 : SYNTHÈSE (BEFORE / AFTER) --- */}
                <Box>
                    <Typography variant="h4" fontWeight={800} color="#37474f" gutterBottom sx={{ borderBottom: "4px solid #43a047", display: "inline-block", mb: 4 }}>
                        Synthèse : La rupture
                    </Typography>

                    <Box sx={{ width: "100%", mb: 4 }}>
                        <Grid container spacing={3}>
                            {/* 2018 - GOOD */}
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Paper sx={{ p: 3, height: "100%", borderRadius: 4, bgcolor: "#e8f5e9", border: "1px solid #c8e6c9" }}>
                                    <Chip label="2018" color="success" sx={{ fontWeight: 800, fontSize: "1.1rem", mb: 2 }} />
                                    <Typography variant="h6" fontWeight={700} color="#2e7d32" gutterBottom>
                                        L'excellence financière
                                    </Typography>
                                    <Typography variant="body2" color="#1b5e20">
                                        En 2018, Bois-le-Roi faisait partie des communes les mieux gérées financièrement :
                                        des charges de fonctionnement et un endettement plus faibles, ainsi qu'une trésorerie plus abondante que les communes comparées.
                                    </Typography>
                                    <Stack spacing={1} mt={2}>
                                        <Box display="flex" alignItems="center"><FontAwesomeIcon icon={faArrowDown} style={{ marginRight: 8 }} /> Charges de fonctionnement plus faibles</Box>
                                        <Box display="flex" alignItems="center"><FontAwesomeIcon icon={faArrowDown} style={{ marginRight: 8 }} /> Endettement plus faible</Box>
                                        <Box display="flex" alignItems="center"><FontAwesomeIcon icon={faArrowUp} style={{ marginRight: 8 }} /> Trésorerie plus abondante</Box>
                                    </Stack>
                                </Paper>
                            </Grid>

                            {/* 2024 - BAD */}
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Paper sx={{ p: 3, height: "100%", borderRadius: 4, bgcolor: "#ffebee", border: "1px solid #ffcdd2" }}>
                                    <Chip label="2024" color="error" sx={{ fontWeight: 800, fontSize: "1.1rem", mb: 2 }} />
                                    <Typography variant="h6" fontWeight={700} color="#c62828" gutterBottom>
                                        La dégradation brutale
                                    </Typography>
                                    <Typography variant="body2" color="#b71c1c" paragraph>
                                        En 2024, Bois-le-Roi fait désormais partie des villes dont la gestion financière est seulement dans la « moyenne » des communes comparées,
                                        en raison de l'augmentation de <b>61%</b> des charges de fonctionnement, de <b>399%</b> de son endettement,
                                        cumulée à la baisse de <b>51%</b> de sa trésorerie.
                                    </Typography>

                                    {/* Nested Grid pour les stats */}
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Grid container spacing={1}>
                                            <Grid size={{ xs: 4 }}>
                                                <Box textAlign="center" p={1} bgcolor="white" borderRadius={2} boxShadow={1}>
                                                    <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ fontSize: "0.7rem" }}>CHARGES</Typography>
                                                    <Typography variant="h6" fontWeight={800} color="#c62828" sx={{ fontSize: "1rem" }}>+61%</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 4 }}>
                                                <Box textAlign="center" p={1} bgcolor="white" borderRadius={2} boxShadow={1}>
                                                    <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ fontSize: "0.7rem" }}>DETTE</Typography>
                                                    <Typography variant="h6" fontWeight={800} color="#c62828" sx={{ fontSize: "1rem" }}>+399%</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ xs: 4 }}>
                                                <Box textAlign="center" p={1} bgcolor="white" borderRadius={2} boxShadow={1}>
                                                    <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ fontSize: "0.7rem" }}>TRÉSO</Typography>
                                                    <Typography variant="h6" fontWeight={800} color="#c62828" sx={{ fontSize: "1rem" }}>-51%</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Typography variant="body2" color="#b71c1c" sx={{ mt: 2 }}>
                                        Pourtant, cette dégradation financière n'a pas affecté les communes voisines : Bois-le-Roi est celle qui a subi la détérioration la plus marquée.
                                        De plus, cette déliquescence financière est intervenue alors même que le levier fiscal avait été fortement sollicité.
                                    </Typography>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>

                <Box p={3} sx={{ borderLeft: "4px solid #c62828", bgcolor: "#fffaf0", borderRadius: 2 }}>
                    <Typography variant="body2" fontStyle="italic" color="text.secondary">
                        Cette évolution n'est pas une fatalité, mais la conséquence d'une gestion défaillante.{" "}
                        <b>Nous estimons qu'il sera temps d'y mettre un terme dès mars 2026.</b>
                    </Typography>
                </Box>

                {/* --- SECTION 3 : STRATE NATIONALE --- */}
                <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
                    <Stack direction="row" spacing={2} alignItems="center" mb={3}>
                        <FontAwesomeIcon icon={faUniversity} size="2x" color="#1976d2" />
                        <Typography variant="h5" fontWeight={700} color="#1565c0">
                            Évolution par rapport à des communes comparables au niveau national
                        </Typography>
                    </Stack>

                    <Typography paragraph color="text.secondary">
                        Bois-le-Roi, par la taille de sa population, est comparée à l'ensemble des communes comptant entre 5&nbsp;000 à 10&nbsp;000 habitants
                        (nommé la « strate ») au niveau national.
                        En 2018, Bois-le-Roi bénéficiait d'une situation financière solide, largement supérieure à celle de sa strate.
                        En 2024, Bois-le-Roi n'est plus qu'une commune dont la gestion financière est seulement dans la « moyenne » de sa strate.
                    </Typography>

                    <Typography paragraph color="text.secondary" sx={{ mb: 3 }}>
                        En effet, la trajectoire financière depuis 2018 fait apparaître une lourde dégradation :
                    </Typography>

                    <Grid container spacing={4} alignItems="center">
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Stack spacing={2}>
                                <Paper elevation={0} sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
                        <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
                            • Charges de fonctionnement / hab.
                        </Typography>
                        <Typography variant="body2">
                            En 2018, les charges de fonctionnement par habitant étaient{" "}
                            <span style={{ color: "#2e7d32", fontWeight: "bold" }}>17%</span> inférieures à celles de la strate,
                            contre{" "}
                            <span style={{ color: "#c62828", fontWeight: "bold" }}>9%</span> supérieures en 2024.
                        </Typography>
                </Paper>

                <Paper elevation={0} sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
                    <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
                        • Trésorerie / hab.
                    </Typography>
                    <Typography variant="body2">
                        En 2018, la trésorerie par habitant était{" "}
                        <span style={{ color: "#2e7d32", fontWeight: "bold" }}>189%</span> plus importante que le niveau de la strate
                        (soit près de 3 fois plus importante), contre seulement{" "}
                        <span style={{ fontWeight: "bold" }}>21%</span> supérieure en 2024.
                    </Typography>
                </Paper>

                <Paper elevation={0} sx={{ p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
                    <Typography variant="subtitle2" fontWeight={700} color="primary" gutterBottom>
                        • Dette / hab.
                    </Typography>
                    <Typography variant="body2">
                        En 2018, l'endettement par habitant était{" "}
                        <span style={{ color: "#2e7d32", fontWeight: "bold" }}>81%</span> plus faible que celui de la strate
                        (soit près de 5 fois plus faible), contre un niveau comparable à la strate en 2024.
                    </Typography>
                </Paper>
            </Stack>
        </Grid>

    <Grid size={{ xs: 12, md: 6 }}>
        <GraphImage src={imgStrate} alt="Écarts financiers BLR vs Strate (€/hab)" />
        <Typography variant="caption" display="block" align="center" color="text.secondary" mt={1}>
            Écarts financiers entre Bois-le-Roi et sa « Strate » (en € par habitant) — Source : Trésor Public
        </Typography>
    </Grid>
</Grid>

    <Typography paragraph color="text.secondary" sx={{ mt: 3, mb: 0 }}>
        Ainsi, en 2018, Bois-le-Roi bénéficiait d'une situation financière solide, largement supérieure à celle de sa strate.
        En 2024, la situation financière de Bois-le-Roi n'est plus que dans la « moyenne » de sa strate.
        <br />
        <Typography component="span" variant="caption" color="text.secondary">
            Source : Trésor Public
        </Typography>
    </Typography>
</Paper>

    {/* --- SECTION 4 : COMMUNES VOISINES --- */}
    <Box>
        <Box mb={4} textAlign="center">
            <Chip icon={<FontAwesomeIcon icon={faSearchDollar} />} label="Le Panel Local" color="primary" sx={{ mb: 1 }} />
            <Typography variant="h5" fontWeight={800} color="#37474f">
                Évolution par rapport à des communes voisines
            </Typography>
            <Typography variant="body2" color="text.secondary" mt={1}>
                Bois-le-Roi, par sa localisation, est comparée à des communes situées à proximité (« le panel »).
                Le panel est constitué des communes suivantes : Avon, Bourron-Marlotte, Chartrettes, Fontainebleau, Héricy,
                Samois-sur-Seine, Samoreau, Thomery et La Rochette.
            </Typography>
        </Box>

        <Stack spacing={4}>
            {/* Point 1 */}
            <Paper elevation={2} sx={{ p: 3, borderRadius: 3, borderLeft: "6px solid #ef6c00" }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography variant="h6" fontWeight={700} color="#ef6c00" gutterBottom>
                            1. La plus forte augmentation des charges de fonctionnement
                        </Typography>
                        <Typography variant="body2" color="text.secondary" paragraph>
                            Bois-le-Roi affiche la pire performance : ses charges de fonctionnement ont augmenté de <b>61%</b>,
                            soit une progression près de <b>4 fois supérieure</b> à l'inflation (<b>16%</b> entre 2018 et 2024).
                        </Typography>
                        <Chip label="≈ 4x l'inflation (16%)" size="small" sx={{ bgcolor: "#ef6c00", color: "white", fontWeight: 700 }} />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <GraphImage src={imgCharges} alt="Évolution Charges 2018-2024" />
                    </Grid>
                </Grid>
            </Paper>

            {/* Point 2 */}
            <Paper elevation={2} sx={{ p: 3, borderRadius: 3, borderLeft: "6px solid #ef6c00" }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography variant="h6" fontWeight={700} color="#ef6c00" gutterBottom>
                            2. La deuxième plus forte baisse de sa trésorerie, après Fontainebleau
                        </Typography>
                        <Typography variant="body2" color="text.secondary" paragraph>
                            Alors que sept communes ont accru leur trésorerie, Bois-le-Roi fait au contraire partie des trois communes
                            ayant enregistré une baisse de leur trésorerie.
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Source : Trésor Public
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <GraphImage src={imgTresorerie} alt="Évolution Trésorerie 2018-2024" />
                        <Typography variant="caption" display="block" align="center" color="text.secondary" mt={1}>
                            Évolution de la trésorerie entre 2018 et 2024 (en %)
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>

            {/* Point 3 */}
            <Paper elevation={2} sx={{ p: 3, borderRadius: 3, borderLeft: "6px solid #c62828" }}>
                <Grid container spacing={3} alignItems="center">
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                            <FontAwesomeIcon icon={faExclamationTriangle} color="#c62828" />
                            <Typography variant="h6" fontWeight={700} color="#c62828">
                                3. La plus forte hausse de l'endettement
                            </Typography>
                        </Stack>
                        <Typography variant="body2" color="text.secondary" paragraph>
                            En matière d'endettement, Bois-le-Roi détient un triste record : <b>+399%</b>,
                            soit une progression <b>10 fois supérieure</b> à celle de la commune affichant la deuxième plus forte hausse.
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Source : Trésor Public
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <GraphImage src={imgDette} alt="Évolution Dette 2018-2024" />
                        <Typography variant="caption" display="block" align="center" color="text.secondary" mt={1}>
                            Évolution de l'endettement entre 2018 et 2024 (en %)
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        </Stack>
    </Box>

    {/* --- CONCLUSION --- */}
    <Paper
        elevation={0}
        sx={{
            p: 6,
            borderRadius: 4,
            textAlign: "center",
            background: "linear-gradient(135deg, #43a047 0%, #66bb6a 100%)",
            color: "white",
            boxShadow: "0 10px 30px rgba(67, 160, 71, 0.3)"
        }}
    >
        <FontAwesomeIcon icon={faUsers} size="3x" style={{ marginBottom: 20, opacity: 0.9 }} />
        <Typography variant="h5" fontWeight={700} gutterBottom>
            Une commune bien gérée, c'est une commune qui peut investir, innover et soutenir ses habitants.
        </Typography>
        <Typography variant="h6" fontWeight={400} sx={{ mt: 2, opacity: 0.9 }}>
            Faisons de la gestion des finances communales un levier d'avenir !
        </Typography>
    </Paper>

</Stack>
</Container>
);
}

export default POST20251230;